import { render, staticRenderFns } from "./RecurringBalanceInsightPopup.vue?vue&type=template&id=2ca386bb&scoped=true"
import script from "./RecurringBalanceInsightPopup.vue?vue&type=script&lang=js"
export * from "./RecurringBalanceInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./RecurringBalanceInsightPopup.vue?vue&type=style&index=0&id=2ca386bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca386bb",
  null
  
)

export default component.exports